import type { TowerStrings } from "./logictower.vi.ts";

/** English twin of `logictower.vi.ts`. */
export const towerEn: TowerStrings = {
  drops: (n) => `Dropped ${n}`,
  hintCost: "Using a hint caps this level at 2 stars. Still want it?",
  resultDrops: (n, best) =>
    n <= best ? `You dropped ${n} times, as neat as the best solution!` : `You dropped ${n} times, the neatest solution takes ${best}.`,
  resultRule: (three, two) => `Three stars for ${three} drops or fewer, two stars for ${two} or fewer.`,
  resultHint: "You used a hint, so 2 stars at most.",
};
